import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  checkGuestToken,
  getJwtToken,
  isUserAuthenticated,
} from "../helpers/auth/authUtils";
import { getCookie, setCookie } from "../helpers/other/cookies";
import { createObjForCookie } from "../helpers/utils";
import { getConversation } from "../redux/chat/actions";
import { setUserInfo, startSocket } from "../redux/rootActions";
import { Tokens } from "../types/webchatConversation";
import ChatWindow from "./ChatWindow";
import MinMaxButton from "./MinMaxButton";

const getTokenFromUrl = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get("token") || null;
};

const WebchatWidget: React.FC = () => {
  const dispatch = useDispatch();
  const isAuthTokenValid = isUserAuthenticated();
  const isGuestTokenValid = checkGuestToken();
  const isOpenWebchatWidget = getCookie("isOpenWebchatWidget");
  const [isOpen, setIsOpen] = useState(
    isOpenWebchatWidget !== null ? isOpenWebchatWidget === "true" : false,
  );
  const [token, setToken] = useState<string | null>(getTokenFromUrl());
  const [tokenIsValid, setTokenIsValid] = useState(false);

  const toggleIsOpen = () => {
    const newState = !isOpen;
    setIsOpen(newState);
    setCookie("isOpenWebchatWidget", newState, createObjForCookie());

    const targetOrigin =
      process.env.REACT_APP_CLIENT_HOST_URL ||
      process.env.REACT_APP_CLIENT_HOST_URL2;

    if (targetOrigin) {
      window.parent.postMessage(newState ? "open" : "close", targetOrigin);
    } else {
      console.error("❌ Nema definisan targetOrigin za postMessage!");
    }
  };

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const allowedOrigins = [
        "https://quiz.firebird.rs",
        "https://www.quiz.firebird.rs",
        "https://quiz-complete-inbox-wcf.firebird.rs",
        "http://localhost:20036",
      ];
      if (!allowedOrigins.includes(event.origin)) return;

      if (typeof event.data === "object" && event.data?.type === "AUTH_TOKEN") {
        console.log("📩 Token primljen putem postMessage:", event.data.token);
        if (!token) setToken(event.data.token);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [token]);

  useEffect(() => {
    if (!token) {
      console.warn("WebchatWidget: Token nije pronađen!");
      return;
    }

    if (token === "xyz123") {
      setTokenIsValid(true);
    } else {
      setTokenIsValid(false);
      console.error("❌ WebchatWidget: Token NIJE validan! Primljen:", token);
    }
  }, [token]);

  useEffect(() => {
    if (isAuthTokenValid || isGuestTokenValid) {
      if (isAuthTokenValid) {
        dispatch(
          setUserInfo(getJwtToken(Tokens.AUTH_TOKEN), Tokens.AUTH_TOKEN),
        );
      } else {
        dispatch(
          setUserInfo(getJwtToken(Tokens.GUEST_TOKEN), Tokens.GUEST_TOKEN),
        );
      }
      dispatch(startSocket());
      dispatch(getConversation());
    }
  }, []);

  useEffect(() => {
    if (isOpen) {
      const targetOrigin =
        process.env.REACT_APP_CLIENT_HOST_URL ||
        process.env.REACT_APP_CLIENT_HOST_URL2;

      if (targetOrigin) {
        window.parent.postMessage(
          {
            type: "SHOW_BALLOON",
            payload: {
              text: "Novi chat je dostupan 🎉",
            },
          },
          targetOrigin,
        );
      }
    }
  }, [isOpen]);

  const sendBalloonMessage = (text: string) => {
    const targetOrigin =
      process.env.REACT_APP_CLIENT_HOST_URL ||
      process.env.REACT_APP_CLIENT_HOST_URL2;

    if (targetOrigin) {
      window.parent.postMessage(
        {
          type: "SHOW_BALLOON",
          payload: { text },
        },
        targetOrigin,
      );
    } else {
      console.error("❌ Nema definisan targetOrigin za postMessage!");
    }
  };

  return (
    <div className={isOpen ? "webchat-widget" : "webchat-widget-closed"}>
      {tokenIsValid ? (
        <>
          {isOpen && <ChatWindow onClick={toggleIsOpen} />}
          <span className={isOpen ? "min-max-button-opened" : ""}>
            <MinMaxButton
              isOpen={isOpen}
              onClick={toggleIsOpen}
              onHoverBalloon={() =>
                sendBalloonMessage("👋 Klikni da započneš razgovor!")
              }
            />
          </span>
        </>
      ) : (
        <div>Token is invalid! Please check the provided token.</div>
      )}
    </div>
  );
};

export default WebchatWidget;
